var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconElexity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#FA9128"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2085 10.8766L7.69184 6.66975C7.63172 6.59326 7.53153 6.54546 7.43134 6.54546H4.52582C4.39557 6.54546 4.31542 6.69844 4.39557 6.79405L8.75385 11.9952L4.40559 17.206C4.32544 17.3016 4.39557 17.4546 4.53584 17.4546H7.44136C7.54155 17.4546 7.63172 17.4067 7.70186 17.3303L11.2185 13.1234C11.7696 12.4637 11.7696 11.5363 11.2085 10.8766V10.8766ZM19.5844 17.206L16.8292 13.9074C16.0878 13.0278 14.9657 12.502 13.7834 12.502H12.6613C12.491 12.502 12.4008 12.6836 12.501 12.8079L16.2782 17.3303C16.3383 17.4067 16.4385 17.4546 16.5386 17.4546H19.4442C19.6045 17.4546 19.6746 17.3016 19.5844 17.206V17.206ZM19.4742 6.54546H16.5687C16.4685 6.54546 16.3783 6.59326 16.3082 6.66975L12.531 11.1921C12.4308 11.3164 12.521 11.4981 12.6913 11.4981H13.8135C14.9957 11.4981 16.1178 10.9722 16.8593 10.0926L19.6145 6.79405C19.6746 6.68887 19.6045 6.54546 19.4742 6.54546Z",
    fill: "#FAFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconElexity);
export default __webpack_public_path__ + "static/media/icon_elexity.de0adeaeaa85f1e498857440275264ec.svg";
export { ForwardRef as ReactComponent };